import React, { useGlobal } from 'reactn'
import { RouteProps } from 'react-router-dom'
import LoginComponent from 'ui/pages/med/Login'
import { useCallback, useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import {
  getAppClientId,
  getInformationToMed,
  getMedicalInstitutions,
  postForgotPassword,
  postLogin,
} from './fetch'
import Empty from 'ui/pages/med/Empty'
import { routePaths } from 'app/routes'
import GaEvents from '../shared/GaEvents'
import { Api401Error, ApiErrorWithNoMessage, NotFoundError } from '../client'

const Login = ({ children }: RouteProps) => {
  const [user, setUser] = useGlobal('user')
  const [appClientId, setAppClientId] = useGlobal('appClientId')
  const [, setUpdate] = useGlobal('updateInformation')

  const navigate = useNavigate()

  // NOTE: ログインセッションによる認証チェックが走っている間はEmptyを表示
  const [authenticating, setAuthenticating] = useState<boolean>(true)

  const getUser = useCallback(() => {
    getMedicalInstitutions()
      .then((data) => setUser(data))
      .catch((e) => {
        if (e instanceof ApiErrorWithNoMessage) {
          // NOTE: 予期しないエラー
          navigate(routePaths.error)
        }
        return //  NOTE: 予期しなエラー以外はログイン画面表示になる
      })
      .finally(() => setAuthenticating(false))
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  useEffect(() => {
    if (!user) {
      getUser()
    } else {
      GaEvents.medicalLogin({ med: user })
      getInformationToMed().then(setUpdate).catch(console.log)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [user])

  useEffect(() => {
    if (!user) return
    if (!appClientId) {
      const results = Promise.all([
        getAppClientId('stripe'),
        getAppClientId('zoom'),
        getAppClientId('teams'),
      ])
      results
        .then(([stripe, zoom, teams]) => {
          setAppClientId({
            stripe: stripe.client_id,
            zoom: zoom.client_id,
            teams: teams.client_id,
          })
        })
        .catch((e) => {
          if (e instanceof NotFoundError) {
            return
          }
          if (e instanceof Api401Error) {
            return
          }
          console.log(e)
          navigate(routePaths.error)
        })
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [user, appClientId])

  if (authenticating) {
    return <Empty />
  }

  return (
    <>
      {user ? (
        children
      ) : (
        <LoginComponent
          onSubmitForgotPassword={postForgotPassword}
          onSubmit={(data) => postLogin(data).then(() => getUser())}
        />
      )}
    </>
  )
}

export default Login
